import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { Controller, FieldValues, UseControllerProps } from 'react-hook-form';

interface ControlledCheckboxFieldProps<TFieldValues extends FieldValues>
  extends UseControllerProps<TFieldValues> {
  isVisible?: boolean;
  disabled?: boolean;
  label: React.ReactNode;
  'data-testid'?: string;
}

export function ControlledCheckboxField<TFieldValues extends FieldValues>({
  name,
  control,
  rules,
  isVisible = true,
  disabled,
  label,
  'data-testid': dataTestId,
}: ControlledCheckboxFieldProps<TFieldValues>): React.JSX.Element | null {
  if (!isVisible) return null;

  return (
    <Controller<TFieldValues>
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value, onChange } }) => (
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => onChange(e.currentTarget.checked)}
              checked={Boolean(value)}
              data-testid={dataTestId}
              disabled={disabled}
            />
          }
          label={label}
        />
      )}
    />
  );
}
